/*
 * @Author: wp
 * @Date: 2023-01-04 15:32:57
 * @Descripttion:
 */
import Registered from '~/pages/login/registered.vue'
import Login from '~/pages/login/index.vue'
import WxCallback from '~/pages/login/wxCallback.vue'
import QqCallback from '~/pages/login/qqCallback.vue'
import ForgetPwd from '~/pages/login/forgetPwd.vue'
export default [
    {
        path: '/registered',
        name: 'registered',
        component: Registered,
        meta: { title: '注册', belongGroup: 'login' }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { title: '登录', belongGroup: 'login' }
    },
    {
        path: '/wxCallback',
        name: 'wxCallback',
        component: WxCallback,
        meta: { belongGroup: 'login' }
    },
    {
        path: '/qqCallback',
        name: 'qqCallback',
        component: QqCallback,
        meta: { belongGroup: 'login' }
    },
    {
        path: '/forgetPwd',
        name: 'forgetPwd',
        component: ForgetPwd,
        meta: { title: '忘记密码', belongGroup: 'login' }
    }
]
